export const environment = {
  production: false,
  baseUrl: window.localStorage.getItem('baseUrl') || 'https://test.rack.coach',
  cordova: true,
  stripeKey: 'pk_test_8CR9lYWAhU6Ymxaw2xFcE610'
};
 